<template lang="pug">
  b-container(fluid,style="height: 100%;")
    h5(v-if="iFrame == 'about:blank'") Cargando formulario...
    iframe(:src="iFrame", frameborder="0", style="width:100%; height:100%")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'

export default {
  data: function () {
    return {
      iFrame : 'about:blank',
    }
  },
  computed: {

  },
  methods: {
    ...mapActions(['account/iFrame']),
    getContract () {
      let self = this
      // this.showLoadingScreen()

      this['account/iFrame']({
        account_id: self.$route.params.account_id,
        callback: res => {
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            console.log(res.resource)
            this.iFrame = res.resource;
          }
        }
      })
    }
  },
  mounted () {
    this.getContract()
  }
}
</script>

<style lang="scss" scoped>
</style>
